import React, { useEffect, useState } from 'react'
import { Button } from '../atoms/Button';
import { connect } from "react-redux";
import i18nstring, { strings } from "../../i18n";
import { getBadgeResponses, handleCreateBadgeRequest, handleDeleteBadgeRequest, handleEditBadgeRequest } from '../../redux/actions/Badge';
import { BadgeModal, BADGE_ACCOUNT_TYPES, badgeTypeLabel } from '../organisms/Modal';
import { Icon, Image, Table } from 'semantic-ui-react';
import moment from 'moment';
import placeHolder from "../../images/icons/placeHolder.png";
import ConfirmationPopup from '../atoms/ConfirmationPopup';


const headerStyle = {
  borderRight: "1px solid #ddd"
};

const rowStyle = { 
  border: "none",
};

const tableStyle = {
  fontFamily: 'Lato, sans-serif', 
  borderCollapse: "collapse" 
};


const Badges = ({badges, ...props}) => {
  const [expandedRow, setExpandedRow] = useState(null);
  const [toggleModal, setToggle] = useState(false);
  const [selectedBadge, setSelectedBadge] = useState();
  const [data, setData] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    useEffect(() => {
      props.attemptGetBadges(true);
    }, []);

    useEffect( () => {
      if (badges)
        setData(badges);
    }, [badges]);

    const createBadge = (data, icon) => {
      props.attemptCreateBadges(data, icon);
    };

    const editBadge = (id, data, icon) => {
      props.attemptEditBadge(id, data, icon);
    };

  const handleRowClick = (rowIndex) => {
    if (expandedRow === rowIndex) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowIndex);
    }
  };

  const deleteBadge = (id) => {
    props.attemptDeleteBadge(id)
  }

  function titleCase(str) {
    return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
  }
  
  const renderRow = (heading, value) => {
    return (
      <div className="row-container">
        <span className="label-title">{heading}: </span>
        <span className="label-value">{value}</span>
      </div>
    );
  };

  const closeBadgeModal = () => {
    setSelectedBadge(null);
    setToggle(false)
  }

  const getDateString = (date) => {
    if (!date) return '-';
    return moment(date).format('DD MMM YYYY hh:mm a');
  }

  const handleConfirmationClick = () => {
    deleteBadge(selectedBadge?.id)
  }

  return (
    <div className="main_container_section">
      <div className="refresh_container">
        <Button
          onClick={() => {
            setToggle(true);
            setSelectedBadge(null);
          }}
        >
          {i18nstring(strings.CREATE_BADGE)}
        </Button>
      </div>
      {badges && badges.length > 0 && (
        <Table celled style={tableStyle}>
          <Table.Header>
            <Table.Row
              style={{
                backgroundColor: "#f4f4f4",
                color: "#333",
                fontWeight: "bold"
              }}
            >
              <Table.HeaderCell style={headerStyle}></Table.HeaderCell>
              <Table.HeaderCell style={headerStyle}>
                Account Type
              </Table.HeaderCell>
              <Table.HeaderCell style={headerStyle}>
                Badge Type
              </Table.HeaderCell>
              <Table.HeaderCell style={headerStyle}>
                Badge Value
              </Table.HeaderCell>
              <Table.HeaderCell style={headerStyle}>Status</Table.HeaderCell>
              <Table.HeaderCell style={{ width: "120px", borderRight: "none" }}>
                Actions
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {data.map((row, index) => (
              <React.Fragment key={row.id}>
                <Table.Row
                  onClick={() => handleRowClick(index)}
                  active={expandedRow === index}
                  style={{
                    cursor: "pointer",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "transparent !important"
                  }}
                  className={"active-row"}
                >
                  <Table.Cell
                    style={{
                      width: "40px",
                      paddingLeft: "10px",
                      border: "none"
                    }}
                  >
                    <i
                      class={
                        expandedRow !== index
                          ? "angle right icon"
                          : "angle down icon"
                      }
                    ></i>
                  </Table.Cell>
                  <Table.Cell style={rowStyle}>
                    {BADGE_ACCOUNT_TYPES[row.accountType] ||
                      titleCase(row.accountType)}
                  </Table.Cell>
                  <Table.Cell style={rowStyle}>
                    {badgeTypeLabel(row.type)}
                  </Table.Cell>
                  <Table.Cell style={rowStyle}>{row.value}</Table.Cell>

                  <Table.Cell style={rowStyle}>
                    {row?.isActive === true
                      ? i18nstring(strings.ACTIVE)
                      : i18nstring(strings.INACTIVE)}
                  </Table.Cell>
                  <Table.Cell textAlign="center" style={rowStyle}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px"
                      }}
                      onClick={e => e.stopPropagation()}
                    >
                      <Icon
                        name="edit"
                        color="blue"
                        onClick={() => {
                          setSelectedBadge(row);
                          setToggle(true);
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <Icon
                        name="trash"
                        color="red"
                        onClick={() => {
                          setSelectedBadge(row);
                          setShowConfirmationModal(true)}
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </Table.Cell>
                </Table.Row>

                {expandedRow === index && (
                  <Table.Row style={{ backgroundColor: "#efefef" }}>
                    <Table.Cell colSpan="6">
                      <div
                        className="expanded-table-row-badge"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center"
                        }}
                      >
                        <div className="expanded-table-row-col">
                          <div className="table_cell_image">
                            <Image
                              className="badge_image"
                              src={row.iconUrl || placeHolder}
                            />
                          </div>
                        </div>
                        <div className="expanded-table-row-col-2">
                          {renderRow(
                            i18nstring(strings.ASSIGNED_COUNT),
                            row.assignedCount || 0
                          )}
                          {renderRow(
                            i18nstring(strings.TITLE_EN),
                            row.title?.["en-US"]
                          )}
                          {renderRow(
                            i18nstring(strings.TITLE_ES),
                            row.title?.["es-US"]
                          )}

                          {renderRow(
                            i18nstring(strings.DESCRIPTION_EN),
                            row.description?.["en-US"]
                          )}
                          {renderRow(
                            i18nstring(strings.DESCRIPTION_ES),
                            row.description?.["es-US"]
                          )}
                          {renderRow(
                            i18nstring(strings.CREATED_DATE),
                            getDateString(row.creationDate)
                          )}
                          {renderRow(
                            i18nstring(strings.MODIFIED_DATE),
                            getDateString(row.modifiedDate)
                          )}
                        </div>
                      </div>
                    </Table.Cell>
                  </Table.Row>
                )}
              </React.Fragment>
            ))}
          </Table.Body>
        </Table>
      )}
      {toggleModal === true && (
        <BadgeModal
          badge={selectedBadge}
          createBadge={createBadge}
          editBadge={editBadge}
          toggleModal={toggleModal}
          setToggle={closeBadgeModal}
        />
      )}
      {showConfirmationModal && (
        <ConfirmationPopup
          title={i18nstring(strings.CONFIRMATION)}
          message={i18nstring(strings.DELETE_CONFIRMATION_MESSAGE)}
          primaryButtonText={i18nstring(strings.CONFIRM)}
          onPrimaryButtonClicked={handleConfirmationClick}
          open={showConfirmationModal}
          setOpen={setShowConfirmationModal}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  badges: state.badge.items,
});

const mapDispatchToProps = dispatch => {
  return {
    attemptGetBadges: (includeCounts) => dispatch(getBadgeResponses(includeCounts)),
    attemptCreateBadges: (data, icon) => dispatch(handleCreateBadgeRequest(data, icon)),
    attemptEditBadge: (id, data, icon) => dispatch(handleEditBadgeRequest(id, data, icon)),
    attemptDeleteBadge: (id) => dispatch(handleDeleteBadgeRequest(id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Badges);